import { Box } from '@mui/material';
import type { FC } from 'react';
import { VyDialog } from '../../../../../components/new-design/feedback/VyDialog';
import { VyTable } from '../../../../../components/new-design/table/vy-table/VyTable';
import type { CreditLedgerEntry } from './credit-ledger-entry';
import { getCreditsUsageColumns } from './get-credits-usage-columns';

type Props = {
  open: boolean;
  onClose: () => void;
  entries: CreditLedgerEntry[];
  loading?: boolean;
};

export const CreditsUsageDialog: FC<Props> = ({ open, onClose, entries, loading }) => {
  return (
    <VyDialog
      data-vy="credits-usage-dialog"
      open={open}
      onClose={onClose}
      label="Credits usage"
      maxWidth="md"
    >
      <Box sx={{ height: 480 }}>
        <VyTable<CreditLedgerEntry>
          tableName="credits-usage"
          items={entries}
          itemsCount={entries.length}
          columns={getCreditsUsageColumns()}
          showPagination={false}
          sortingMode="client"
          loadingItems={loading}
          sx={{
            border: '1px solid #F5F6FA',
            borderRadius: '8px',
            backgroundColor: '#FFFFFF',
            '--DataGrid-rowBorderColor': '#E8EBF2',
            '& .MuiDataGrid-columnHeader': {
              backgroundColor: '#F5F6FA',
              border: 'none',
            },
            '& .MuiDataGrid-virtualScroller, & .MuiDataGrid-row': {
              backgroundColor: '#FFFFFF',
            },
          }}
        />
      </Box>
    </VyDialog>
  );
};
